import { render } from "./dataCockpit.vue?vue&type=template&id=7c58e954&scoped=true"
import script from "./dataCockpit.vue?vue&type=script&lang=js"
export * from "./dataCockpit.vue?vue&type=script&lang=js"

import "./dataCockpit.vue?vue&type=style&index=0&id=7c58e954&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c58e954"]])

export default __exports__